import { BrowseViewResponseDto, ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { CompetenceType } from '@/common';
import env from '@/env';

export const getCompetenceTypes = async ({
  page,
  pageSize,
  search,
}: {
  page: number;
  pageSize: number;
  search: string;
}): Promise<BrowseViewResponseDto<CompetenceType>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/competence-types?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<CompetenceType>;
  return response;
};
